export const baseUrl = "https://api.thalamusmedia.com";
